import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import { Card, Input, Button, Typography, Form } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginHeader from "../components/loginheader/Loginheader";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export default function ChangePassword() {
    const { authData, backUrl } = useContext(AuthContext);

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [data, setData] = useState({
        emp_code: authData?.employee?.user?.username || "",
        new_password: "",
        confirm_password: ""
    });

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    };

    const changePassword = async () => {
        if (!data.new_password || !data.confirm_password) {
            toast.error("Please fill all fields", { position: "top-right" });
            return;
        }

        if (data.new_password !== data.confirm_password) {
            toast.error("Passwords do not match", { position: "top-right" });
            return;
        }

        try {
            setLoading(true);

            const res = await axios.post(
                `${backUrl}/api/emp/admin-reset-password/`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            toast.success("Password changed successfully!", {
                position: "top-right",
            });

            setData({
                ...data,
                new_password: "",
                confirm_password: "",
            });

            setTimeout(() => {
                navigate("/");
            }, 1500);

        } catch (error) {
            toast.error(
                error?.response?.data?.error || "Failed to change password",
                { position: "top-right" }
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <LoginHeader />
            <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{
                    marginTop: "25px",
                    padding: "4px 8px",
                    color: "#0e497b",
                    fontWeight: "500",
                    marginLeft:'150px'
                }}
            >
                Back
            </Button>
            <div
                style={{
                    minHeight: "90vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#ffffffff",
                    padding: "20px",
                }}
            >
                <Card
                    style={{
                        width: "100%",
                        maxWidth: "450px",
                        padding: "25px",
                        borderRadius: "12px",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                        background: "#fff",
                    }}
                >


                    <Title
                        level={4}
                        style={{
                            textAlign: "center",
                            marginBottom: "25px",
                            color: "#0e497b",
                            fontWeight: "600",
                        }}
                    >
                        Change Password
                    </Title>

                    <Form layout="vertical">
                        <Form.Item label="Employee Code" style={{ fontWeight: 500 }}>
                            <Input
                                value={data.emp_code}
                                disabled
                                style={{ background: "#f5f5f5", fontWeight: 600 }}
                            />
                        </Form.Item>

                        <Form.Item label="New Password" style={{ fontWeight: 500 }}>
                            <Input.Password
                                name="new_password"
                                value={data.new_password}
                                onChange={handleChange}
                                placeholder="Enter new password"
                                style={{ padding: "10px" }}
                            />
                        </Form.Item>

                        <Form.Item label="Confirm Password" style={{ fontWeight: 500 }}>
                            <Input.Password
                                name="confirm_password"
                                value={data.confirm_password}
                                onChange={handleChange}
                                placeholder="Re-enter new password"
                                style={{ padding: "10px" }}
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            block
                            loading={loading}
                            onClick={changePassword}
                            style={{
                                height: "45px",
                                marginTop: "10px",
                                borderRadius: "6px",
                                fontSize: "16px",
                                fontWeight: "600",
                                background: "#0e497b",
                            }}
                        >
                            Change Password
                        </Button>
                    </Form>
                </Card>
            </div>

            <ToastContainer />
        </>
    );
}